export const ExpenseSteps = [
  {
    target: ".expense-taxable-tour",
    title: "Taxable (Expense)",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        {/* <p style={{fontSize:"14px"}}>Indicate whether the expense is taxable:</p> */}
        <div>
          <strong>Yes :-</strong>
          <br />
          Tax will be calculated and included as part of the expense.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>No :-</strong>
          <br />
          No tax will be applied to this expense.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
];

export const BuySteps = [
  {
    target: ".order-status-tour",
    title: "Order Status",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Ordered :-</strong>
          <br />
          The order has been placed by the customer.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Approved :-</strong>
          <br />
          The order has been reviewed and approved for processing.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Shipped :-</strong>
          <br />
          The order has been dispatched and is on the way to the customer.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
  },
  {
    target: ".transaction-status-tour",
    title: "Transaction Status",
    content: (
      <div style={{ fontSize: "14px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Paid :-</strong>
          <br />
          Full payment has been received.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Partial Paid :-</strong>
          <br />A part of the total amount has been paid; balance is pending.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Advance :-</strong>
          <br />A partial advance amount was collected before order fulfillment.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
  },
];

export const SaleSteps = [
  {
    target: ".sale-type-tour",
    title: "Select Sale Type",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Confirm Sale :-</strong>
          <br />A completed transaction ready for invoicing and full payment.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Advance Sale :-</strong>
          <br />
          Accept a partial payment in advance; suitable for bookings or
          reservations.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Estimate Sale :-</strong>
          <br />
          Send a quotation to your customer before confirming the order.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
  {
    target: ".delivery-type-tour",
    title: "Select Delivery Method",
    content: (
      <div style={{ fontSize: "14px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Takeout :-</strong>
          <br />
          The customer collects the order immediately.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Scheduled Pickup :-</strong>
          <br />
          The order will be picked up at a specified time.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Home Delivery :-</strong>
          <br />
          Deliver the order directly to the customer’s address.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
];

export const IncomeSteps = [
  {
    target: ".income-taxable-tour",
    title: "Taxable (Income)",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        {/* <p style={{fontSize:"14px"}}>Indicate whether the expense is taxable:</p> */}
        <div>
          <strong>Yes :-</strong>
          <br />
          Tax will be calculated and included as part of the Income.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>No :-</strong>
          <br />
          No tax will be applied to this Income.
        </div>
        {/* <div style={{ marginTop: "1px" }}>
                 <strong>Shipped :-</strong>
                 <br />
                 The order has been dispatched and is on the way to the customer.
               </div> */}
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
];

export const CustomerSteps = [
  {
    target: ".bulk-upload-customer-tour",
    title: "Bulk Upload Customers",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Quickly add multiple customers at once :-</strong>
          <br />
          Download the sample file and fill in customer details.
          <br />
          Upload the file to import all customers in one go.
          <br />
          Saves time when adding customers in bulk.
        </div>
        {/* <p>Quickly add multiple customers at once:</p>
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          <li>Download the sample file and fill in customer details.</li>
          <li style={{ marginTop: "8px" }}>
            Upload the file to import all customers in one go.
          </li>
          <li style={{ marginTop: "8px" }}>
            Saves time when adding customers in bulk.
          </li>
        </ul> */}
      </div>
    ),
    disableBeacon: true,
  },
];

export const EmployeeSteps = [
  {
    target: ".employee-role-tour",
    title: "Employee Role",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Default Roles :-</strong>
          <br />
          Choose from predefined roles like Admin, Manager.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Custom Roles :-</strong>
          <br />
          Create your own roles with specific permissions (e.g., create, update,
          Delete) tailored to your organization's needs.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
  {
    target: ".employee-type-tour",
    title: "Employee Type",
    content: (
      <div style={{ fontSize: "13px", lineHeight: "1.6", textAlign: "left" }}>
        <div>
          <strong>Full Time :-</strong>
          <br />
          Permanent employees with full working hours and benefits.
        </div>
        <div style={{ marginTop: "1px" }}>
          <strong>Part Time :-</strong>
          <br />
          Employees working limited hours with proportionate pay and fewer
          benefits.
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "left",
  },
];
